import { BASE_URL } from '@constants';

const sanitizeEndpoint = (endpoint: string | number) =>
  String(endpoint).replace(/^\/|\/$/g, '');

export const composeUrl = (endpoint: string) =>
  `${BASE_URL}/${sanitizeEndpoint(endpoint)}`;
